import { t } from "@lingui/macro";

import { Button } from "@whoosh/design-system/src/components/controls";

import { LogOutMutationString } from "../../screens/Profile/mutations/LogOut";
import { useMutationWithError } from "../../utils/hooks/useMutationWithError";
import { useHandleLogOutCleanUp } from "../Authentication/hooks/useHandleLogOutCleanUp";

type SignOutButtonProps = {
  resetError: () => void;
};

export const SignOutButton = ({ resetError }: SignOutButtonProps) => {
  const [tryLogOut] = useMutationWithError(LogOutMutationString);
  const handleLogOutCleanup = useHandleLogOutCleanUp();

  const onCompleted = () => {
    handleLogOutCleanup();
  };
  const onErrorCustom = () => {
    !!resetError && resetError();
  };

  const signOut = () => {
    tryLogOut({
      variables: { input: {} },
      onCompleted: (res: any) => onCompleted(),
      onErrorCustom: (error: any) => onErrorCustom(),
    });
  };

  return (
    <Button
      variant="secondary"
      onPress={signOut}
      testID="sign-out-button"
      accessibilityLabel={t`Log Out and Try Again button`}
    >
      {t`Log Out and Try Again`}
    </Button>
  );
};
